const HTML_ENTITIES = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};
const HTML_ENTITY_REGEX = /[&<>"']/g;

/**
 * Escapes HTML special characters to their corresponding HTML entities.
 * This prevents HTML injection and parsing errors when text is inserted into MJML/HTML.
 *
 * @param text - The text to escape
 * @returns The escaped text with HTML entities
 *
 * @example
 * escapeHtmlEntities("Yeah... <3") // Returns "Yeah... &lt;3"
 * escapeHtmlEntities("It's a \"test\" & more") // Returns "It&#39;s a &quot;test&quot; &amp; more"
 */
export const escapeHtmlEntities = text => {
  if (!text) {
    return text;
  }
  return text.replace(HTML_ENTITY_REGEX, match => HTML_ENTITIES[match]);
};
//# sourceMappingURL=escape-html-entities.js.map